import React from 'react';

import ArrayXQty     from './ArrayXQty';
import ArrayYQty     from './ArrayYQty';
import ArraySpacingX from './ArraySpacingX';
import ArraySpacingY from './ArraySpacingY';

import ArrayRailsTop    from './ArrayRailsTop';
import ArrayRailsBottom from './ArrayRailsBottom';
import ArrayRailsLeft   from './ArrayRailsLeft';
import ArrayRailsRight  from './ArrayRailsRight';

const NoPanelized = props => (
  <div>
    <div className="row">
      <div className="col-md-6">
        <ArrayXQty {...props} />
      </div>
      <div className="col-md-6">
        <ArraySpacingX {...props} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <ArrayYQty {...props} />
      </div>
      <div className="col-md-6">
        <ArraySpacingY {...props} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <ArrayRailsLeft {...props} />
      </div>
      <div className="col-md-6">
        <ArrayRailsRight {...props} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <ArrayRailsTop {...props} />
      </div>
      <div className="col-md-6">
        <ArrayRailsBottom {...props} />
      </div>
    </div>

    <div className="">
      <div className="alert alert-info alert-panel-size">
        Panel Size {props.parameters.array_x} x {props.parameters.array_y}
      </div>
    </div>
  </div>
);

export default NoPanelized;
